import { inIFrame } from '../_utils';
import React, { forwardRef } from 'react';

type BaseLinkProps = React.DetailedHTMLProps<
  React.AnchorHTMLAttributes<HTMLAnchorElement>,
  HTMLAnchorElement
>;

export const EmbedBaseLink: React.FC<
  React.DetailedHTMLProps<React.AnchorHTMLAttributes<HTMLAnchorElement>, HTMLAnchorElement>
> = ({ children, ...restProps }) => {
  const updatedProps = { ...restProps };

  delete updatedProps.href;

  if (!updatedProps.onClick && restProps.href) {
    updatedProps.onClick = () => {
      window.open(restProps.href, '_self');
    };
  }

  return <a {...updatedProps}>{children}</a>;
};
EmbedBaseLink.displayName = 'EmbedBaseLink';

export const BaseLink = forwardRef<HTMLAnchorElement, BaseLinkProps>(
  ({ children, ...restProps }, ref) => {
    if (inIFrame()) {
      return <EmbedBaseLink {...restProps}>{children}</EmbedBaseLink>;
    }

    return (
      <a ref={ref} {...restProps}>
        {children}
      </a>
    );
  }
);
BaseLink.displayName = 'BaseLink';
